import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { SearchIcon } from "@icarius-icons/";
import { getTheme } from "@icarius-pages/login/selectors";
import { getLocalizedString } from "@icarius-localization/strings";

const useStyles = makeStyles((theme) => ({
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: ({ isDark }) => isDark ? 'var(--quaternaryBackgroundColor)' : '#ffffff',
    border: ({ isDark }) => isDark ? '1px solid rgba(255,255,255,0.3)' : '1px solid #e0e0e0',
    borderRadius: 8,
    padding: '8px 12px',
    marginLeft: 16,
    cursor: 'pointer',
    width: '100%',
    maxWidth: 280,
    transition: 'all 0.2s',
    '&:hover': {
      backgroundColor: ({ isDark }) => isDark ? 'rgba(255,255,255,0.22)' : '#f5f5f5',
    }
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    color: ({ isDark }) => isDark ? '#eaeaea' : '#757575',
    fontSize: '0.95rem',
  },
  searchIcon: {
    marginRight: 8,
    display: 'flex',
    alignItems: 'center'
  },
  rightSection: {
    color: "var(--mainText)",
    fontSize: '0.85rem',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
  },
  kbd: {
    backgroundColor: ({ isDark }) => isDark ? 'var(--secondaryBackgroundColor)' : '#f3f4f6',
    border: ({ isDark }) => isDark ? '1px solid rgba(255, 255, 255, 0.2)' : '1px solid #d1d5db',
    borderRadius: 4,
    padding: '2px 6px',
    fontSize: '0.75rem',
    fontFamily: 'inherit',
    color: ({ isDark }) => isDark ? '#e5e7eb' : '#4b5563',
    boxShadow: ({ isDark }) => isDark ? '0 1px 1px rgba(0,0,0,0.3)' : '0 1px 1px rgba(0,0,0,0.1)',
  }
}));

const MenuSearch = () => {
  const themeState = useSelector(getTheme);
  const isDark = themeState?.theme === 'dark';
  const classes = useStyles({ isDark });

  const handleOpenCommandPalette = () => {
    window.dispatchEvent(new Event('open-command-palette'));
  };

  return (
    <div className={classes.searchContainer} onClick={handleOpenCommandPalette}>
      <div className={classes.leftSection}>
        <div className={classes.searchIcon}>
          <SearchIcon htmlColor={isDark ? '#eaeaea' : '#757575'} style={{ fontSize: 20 }} />
        </div>
        <span>{getLocalizedString("quickSearch")}</span>
      </div>
      <div className={classes.rightSection}>
        <kbd className={classes.kbd}>Ctrl</kbd>
        <span style={{ margin: '0 4px' }}>+</span>
        <kbd className={classes.kbd}>K</kbd>
      </div>
    </div>
  );
}

export default MenuSearch;